import React from 'react'
import { Grid } from '@material-ui/core'
import GrinScanTimelineItem from 'components/Patients/Timeline/V2/MiniTimeline/TimelineItems/GrinScanTimelineItem'
import { MiniTimelineThemes } from 'consts/timelineConsts'
import { makeStyles } from '@material-ui/styles'
import { rangeArray } from 'utils/arrayUtils'
import { Skeleton } from '@material-ui/lab'

const useStyles = makeStyles(theme => ({
  divider: {
    width: 24,
    height: 2,
    backgroundColor: '#CCD9F1',
    margin: '0 2px'
  }
}))

const RecentScansOverview = ({ isLoading, latestScanTimelineItems = [], setSelectedTimelineItem }) => {
  const classes = useStyles()

  const items = isLoading ? rangeArray(3) : latestScanTimelineItems

  return items.length > 0 ? (
    <Grid container alignItems="center" justifyContent="center">
      {items.map((timelineItem, i) => {
        return (
          <React.Fragment key={i}>
            {isLoading ? (
              <Skeleton variant="circle" width={16} height={16} />
            ) : (
              <Grid item>
                <GrinScanTimelineItem
                  theme={MiniTimelineThemes.ScanTracking}
                  timelineItem={timelineItem}
                  isLoading={isLoading}
                  key={timelineItem.id}
                  analyticsPayload={{ source: 'patient-copilot' }}
                  tooltipPlacement="bottom"
                  onSelect={section => setSelectedTimelineItem({ timelineItemId: timelineItem.id, section })}
                />
              </Grid>
            )}
            {i < items.length - 1 && (
              <Grid item>
                <div className={classes.divider} />
              </Grid>
            )}
          </React.Fragment>
        )
      })}
    </Grid>
  ) : (
    <></>
  )
}

export default RecentScansOverview
